// ─── PAYMENT PRESETS — saved bank accounts and payment links ─────────────────
//
//   These appear in the "Payment Information" picker on invoices and receipts.
//   Picking one fills in the fields; staff can still edit them before saving.
//   Everyone sees these (they're part of the app). Details saved from the picker's
//   "Save for next time" button are kept in that browser only.
//
//   currency: accounts matching the invoice/receipt currency are listed first, and
//   the picker warns if an account in a different currency is chosen.
//
//   Invoices store three bank fields (number, name, bank), so extra details that a
//   payer needs — e.g. a US routing number — go in bankName so they appear on the
//   invoice, in the emailed invoice text and on the printout.
// ─────────────────────────────────────────────────────────────────────────────

export const BANK_ACCOUNTS = [
  {
    label: "Zenith Bank — NGN",
    currency: "NGN",
    bankName: "Zenith Bank",
    accountName: "Redlane Travels Limited",
    accountNumber: "1311075462",
  },
  {
    label: "FCMB — NGN",
    currency: "NGN",
    bankName: "FCMB",
    accountName: "Redlane Travels Limited",
    accountNumber: "6700532446",
  },
  {
    label: "Zenith Bank — USD (domiciliary)",
    currency: "USD",
    bankName: "Zenith Bank",
    accountName: "Redlane Travels Limited",
    accountNumber: "5075728743",
  },
  {
    label: "Lead Bank (USA) — USD",
    currency: "USD",
    bankName: "Lead Bank, USA · Routing 101019644 · Checking · 1801 Main St., Kansas City, MO 64108",
    accountName: "Redlane Travels Limited",
    accountNumber: "215350045675",
  },
];

export const PAYMENT_LINKS = [
  // { label: "Paystack — general payments", url: "https://paystack.com/pay/your-page" },
];
